import React from 'react';
import {MdPictureAsPdf} from 'react-icons/md';
import i18n from '../../i18n';
import {PUBLIC_DOWNLOAD_GROUP_SCHEDULE_URL, PUBLIC_DOWNLOAD_TEACHER_SCHEDULE_URL,} from '../../constants/axios';
import {COMMON_DOWNLOAD_PDF} from '../../constants/translationLabels/common';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const getDownloadLink = (entityId, semesterId, languageToRequest) => ({
    group: `${BASE_URL}${PUBLIC_DOWNLOAD_GROUP_SCHEDULE_URL}?groupId=${entityId}&semesterId=${semesterId}${languageToRequest}`,
    teacher: `${BASE_URL}${PUBLIC_DOWNLOAD_TEACHER_SCHEDULE_URL}?teacherId=${entityId}&semesterId=${semesterId}${languageToRequest}`,
});

const DownloadLink = ({entity, semesterId, entityId, label}) => {
    if (!semesterId || !entityId) return null;

    const {language} = i18n;
    const languageToRequest = `&language=${language}`;
    const downloadLink = getDownloadLink(entityId, semesterId, languageToRequest)[entity];

    return (
        <a
            href={downloadLink || ''}
            target="_blank"
            title={i18n.t(COMMON_DOWNLOAD_PDF)}
            aria-label={i18n.t(COMMON_DOWNLOAD_PDF)}
            rel="noreferrer noopener"
            className="pdf_link"
            download
        >
            <MdPictureAsPdf className="svg-btn"/>PDF
            {label && ` (${label})`}
        </a>
    );
};

export default DownloadLink;
